import TextField from "./TextField";
import EmailValidator from "./validators/EmailValidator";

export default class EmailField extends TextField {
  constructor(initialValue) {
    super(1, 100, initialValue);
    this._validators.push(new EmailValidator());
  }
}
